import axios from 'axios'

const http = axios.create({
  baseURL: import.meta.env.VITE_API_BASE || '/app-api',
  timeout: 30000
})

http.interceptors.request.use((config) => {
  const tenantId = import.meta.env.VITE_TENANT_ID || '1'
  config.headers = config.headers || {}
  config.headers['tenant-id'] = tenantId
  return config
})

http.interceptors.response.use(
  (resp) => {
    const body = resp.data
    if (body && typeof body.code === 'number') {
      if (body.code === 0) {
        return body.data
      }
      return Promise.reject(new Error(body.msg || '请求失败'))
    }
    return body
  },
  (err) => Promise.reject(err)
)

export default http
